import React, {useState, useEffect, useCallback} from "react";
import Select from 'react-select'
import Menu from "../../../../components/layout/menu/index";
import FilterSelect from "../../../../components/filters/filterSelect";
import ModalDateSuccess from "../../../../components/shared/modals/modalDateSuccess";
import DynamicTable from "../../../../components/tables/oc/provider/dynamicTable";
import SaveButton from "../../../../components/forms/saveButton";
import CancelButton from "../../../../components/forms/cancelButton";
import { useModuleAdherence } from "../../../../hooks/userAdherence";
import TimeSlotSchedule from "../../../../components/appointment/timeSlotSchedule";
import CalendarSingleDate from "../../../../components/shared/calendarSingleDate";
import {getSchedules, getPositionsPerOrder, createAppointment, getSetting}  from "../../../../client/appointment/index"
import { AuthProvider, useAuth } from "../../../../context/auth";
import { UpdatePdfOC } from "../../../../client/purchaseOrder";
import ModalAlertWarning from "../../../../components/shared/modals/modalAlertWarning";
import PdfViewerModal from "../../../../components/pdfViewer";
import { getCentersList } from "../../../../client/centers/index"
import InputField from "../../../../components/forms/inputField";
import { useLocation } from "react-router-dom";

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      width:'250px',
      minHeight: '40px',
      maxHeight: '120px',
      overflow: 'auto',
      borderColor: '#52526C',
      backgroundColor: 'transparent', 
      '&:hover': { 
      borderColor: '#52526C',
      backgroundColor: 'transparent' 
      },
      boxShadow: state.isFocused ? 'none' : base.boxShadow,
      fontFamily: 'ITC-book, sans-serif',
      fontSize: '14px',
    }),
    menu: (base) => ({
      ...base,
      position: 'absolute',
      zIndex: 9999,
      marginTop: '4px',
      width: '100%',
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
      fontFamily: 'ITC-book, sans-serif', 
      fontSize: '14px'
    }),
    menuPortal: base => ({
      ...base,
      zIndex: 9999,
      fontFamily: 'ITC-book, sans-serif',
      fontSize: '14px'
    }),
  input: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  singleValue: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  multiValue: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  multiValueLabel: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  placeholder: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  option: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  };

  const searchCache = {};

  const statusColors = {
  'Pendientes de entrega': '#FFB81C',
  Vencida: '#FF1C1C',
  };


  const reasonColors = {
  'Disponible para agendar' : '#43B02A',
  'Pendiente de confirmación' : '#FFB81C',
  'Agendada': '#00A3E0'

  }
  
export default function AppointmentProvider() {
  useModuleAdherence(7);
  const location = useLocation();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [collapsedTables, setCollapsedTables] = useState({});
  const [deliveryType, setDeliveryType] = useState('complete');

  const {supplierId} = useAuth();

  const [selectedDate, setSelectedDate] = useState(null);
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedScheduleId, setSelectedScheduleId] = useState(null);

  // Estados para la búsqueda de OCs
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedOC, setSelectedOC] = useState(null); 
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPositions, setTotalPositions] = useState(0);
  const pageSize = 5;

  // Datos para la tabla
  const [tableData, setTableData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [allSelected, setAllSelected] = useState(false);

  //listar centros
  const [centers, setCenters] = useState([]);
  const [loadingCenters, setLoadingCenters] = useState(false);
  const [selectedCenter, setSelectedCenter] = useState("");

  // Estados para cantidades por POS (entrega parcial)
  const [partialQuantities, setPartialQuantities] = useState({});

  //pdf oc
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');

const [savedOCs, setSavedOCs] = useState([]);
const [loadingAppointment, setLoadingAppointment] = useState(false);
  const [originalPositionsData, setOriginalPositionsData] = useState([]);
const [allPositionIds, setAllPositionIds] = useState([]);

  //modal alert
  const [showAlertWarning, setShowAlertWarning] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  
  const [contactNumber, setContactNumber] = useState("");

const [successMessage, setSuccessMessage] = useState('');
const [adminContact, setAdminContact] = useState("");

useEffect(() => {
  const handleScheduleUpdate = (event) => {
    const { scheduleId, remainingSlots } = event.detail;
    setSchedules(prev => prev.map(schedule =>
      schedule.id === scheduleId
        ? { ...schedule, queue_supplier: remainingSlots }
        : schedule
    ));
  };

  window.addEventListener('schedule-updated', handleScheduleUpdate);
  return () => window.removeEventListener('schedule-updated', handleScheduleUpdate);
}, []);

useEffect(() => {
  const fetchAdminContact = async () => {
    try {
      const settingId = 1;
      const response = await getSetting(settingId);
      
      if (response.data && response.data.setting && response.data.setting.key_value) {
        setAdminContact(response.data.setting.key_value);
      }
    } catch (error) {
      console.error("Error al obtener información de contacto administrativo:", error);
      setAdminContact("");
    }
  };
  
  fetchAdminContact();
}, []);

  const formatDisplayDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return d.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const formatDateForAPI = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  
const toggleTableCollapse = (index) => {
  setCollapsedTables(prev => ({
    ...prev,
    [index]: !prev[index]
  }));
};

const handleSelectTime = (time) => {
  setSelectedTime(time);
  
  if (time && schedules.length > 0) {
    const [start, end] = time.split(" - ");
    const schedule = schedules.find(s => 
      s.start_time.substring(0, 5) === start && 
      s.end_time.substring(0, 5) === end
    );
    if (schedule) {
      setSelectedScheduleId(schedule.id);
    }
  }
};

  const handleDateSelect = (dateInfo) => {
    if (dateInfo.selectedDate) {
      setSelectedDate(dateInfo.selectedDate);

      setSelectedTime("");
      setSelectedScheduleId(null);
      fetchSchedulesForDate(dateInfo.selectedDate);
    }
  };

const formatDecimal = (value) => {
  if (value === null || value === undefined) return '';
  const num = parseFloat(value);
  if (isNaN(num)) return '';
      
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

const handleViewDetails = async (purchaseOrderId) => {
  try {
    const response = await UpdatePdfOC(purchaseOrderId);
    
    if (response.data.pdfUrl) {
      setPdfUrl(response.data.pdfUrl);
      setShowPdfModal(true);
    } else if (response.data.message === "La orden de compra ya tiene un PDF asociado.") {
      setPdfUrl(response.data.pdfUrl);
      setShowPdfModal(true);
    } else {
      console.error("No se pudo obtener el PDF:", response.data.message);
    }
  } catch (error) {
    console.error("Error al actualizar el PDF:", error);
    
    if (error.response?.status === 404 && error.response?.data?.message) {
      setAlertMessage(error.response.data.message);
      setShowAlertWarning(true);
    } else if (error.response?.status === 400 && error.response?.data?.message) {
      setAlertMessage(error.response.data.message);
      setShowAlertWarning(true);
    } else {
      setAlertMessage("Error al cargar el PDF. Por favor intente nuevamente.");
      setShowAlertWarning(true);
    }
  }
};

  const searchOCs = useCallback(async (term, page = 1, isForSuggestions = false) => {
    if (!supplierId || !term || term.trim() === "") {
      if (isForSuggestions) {
        setSearchResults([]);
      } else {
        setTableData([]);
        setTotalPositions(0);
        setTotalPages(1);
        setCurrentPage(1);
        setOriginalPositionsData([]);
        setSelectedRows([]);
        setAllSelected(false);
        setPartialQuantities({});
      }
      return;
    }


    const cacheKey = `${supplierId}-${term}-${page}`;
    
    if (!isForSuggestions && searchCache[cacheKey]) {
      const cachedData = searchCache[cacheKey];
      setTableData(cachedData.tableData);
      setOriginalPositionsData(cachedData.originalPositions || []);
      setAllPositionIds(cachedData.allPositionIds || []); 
      setCurrentPage(page);
      setTotalPages(cachedData.totalPages || 1);
      setTotalPositions(cachedData.totalPositions || 0);
      setSearchResults(cachedData.suggestions || []);

      return;
    }

    setLoadingSearch(true);
    try {
      const response = await getPositionsPerOrder(supplierId, term, page, pageSize);
      
      if (response.data) {
        const positions = response.data.positions || [];
        const allPositionIds = response.data.allPositionIds || [];
        
        const uniqueOrderNumbers = [...new Set(
          positions.map(p => {
            if (p.Position && p.Position.orderNumber) {
              return p.Position.orderNumber;
            } else if (p.orderNumber) {
              return p.orderNumber;
            } else if (p.position && p.position.orderNumber) {
              return p.position.orderNumber;
            }
            return "";
          }).filter(Boolean)
        )];

        const filteredOrderNumbers = uniqueOrderNumbers;
          
        const options = filteredOrderNumbers.map(orderNumber => ({
          value: orderNumber,
          label: orderNumber
        }));
        
        if (isForSuggestions) {
          setSearchResults(options);
          return; 
        }
        
        const formattedData = [];
        const originalData = [];
        
        positions.forEach((item, index) => {
          let positionData;
          let lastStatus;
          let scheduleAvailability;
          
          if (item.Position) {
            positionData = item.Position;
            lastStatus = item.LastStatus;
            scheduleAvailability = item.ScheduleAvailability;
          } else if (item.position) {
            positionData = item.position;
            lastStatus = item.lastStatus;
            scheduleAvailability = item.scheduleAvailability;
          } else {
            positionData = item;
          }
          
          originalData.push({
            id: positionData.id,
            orderId: positionData.orderId,
            orderNumber: positionData.orderNumber,
            positionNumber: positionData.positionNumber,
            description: positionData.description,
            cant: positionData.cant,
            unitWeight: positionData.unitWeight,
            emissionDate: positionData.emissionDate,
            deliveryDate: positionData.deliveryDate,
            pricePerUnit: positionData.pricePerUnit,
            canSchedule: scheduleAvailability?.canSchedule,
            scheduleReason: scheduleAvailability?.reason,
            statusName: lastStatus?.statusName
          });
          
          formattedData.push({
            id: positionData.id || index + 1,
            numeroOC: positionData.orderNumber || "",
            pos: (positionData.positionNumber || "").toString(),
            pedido: positionData.description || "",
            cantidad: (positionData.cant || 0).toString(),
            unidad: positionData.unitWeight,
            fechaEmision: formatDisplayDate(positionData.emissionDate),
            fechaEntrega: formatDisplayDate(positionData.deliveryDate),
            precio: formatDecimal(positionData.pricePerUnit),
            detalles: () => handleViewDetails(positionData.orderId),
            canSchedule: scheduleAvailability?.canSchedule,
            scheduleReason: scheduleAvailability?.reason,
            estado: lastStatus?.statusName,
            razon: scheduleAvailability?.reason
          });
        });
        
        searchCache[cacheKey] = {
          tableData: formattedData,
          originalPositions: originalData,
          suggestions: options,
          allPositionIds: allPositionIds,
          totalPages: response.data.pagination?.totalPages || 1,
          totalPositions: response.data.pagination?.totalPositions || 0
        };
        
        setTableData(formattedData);
        setOriginalPositionsData(originalData);
        setAllPositionIds(allPositionIds);
        setSearchResults(options); 
        setCurrentPage(page);
        setTotalPages(response.data.pagination?.totalPages || 1);
        setTotalPositions(response.data.pagination?.totalPositions || 0);

        if (allSelected) {
          const selectableIds = allPositionIds.filter(id => {
            const position = originalData.find(pos => pos.id === id);
            return position?.canSchedule !== false;
          });
          
          const stillAllSelected = selectableIds.length > 0 && 
            selectableIds.every(id => selectedRows.includes(id));
          
          setAllSelected(stillAllSelected);
        }
      }
    } catch (error) {
      console.error("Error al buscar OCs:", error);
      setSearchResults([]);
      setTableData([]);
      setOriginalPositionsData([]);
      setAllPositionIds([]);
    } finally {
      setLoadingSearch(false);
    }
  }, [supplierId, savedOCs]);

  useEffect(() => {
    if (location.state?.ocNumber) {
      const ocNumber = location.state.ocNumber;
      
      setSearchTerm(ocNumber);
      
      const ocOption = {
        value: ocNumber,
        label: ocNumber
      };
      
      setSelectedOC(ocOption);
      
      searchOCs(ocNumber, 1, false);
    }
  }, [location.state, searchOCs]);
  
  const loadCenters = useCallback(async () => {
    try {
      setLoadingCenters(true);
      const response = await getCentersList();
      
      if (response.data) {
        const centersOptions = response.data.map(center => ({
          id: center.id,  
          name: center.name 
        }));
        
        setCenters(centersOptions);
      }
    } catch (error) {
      console.error("Error al cargar centros:", error);
      setCenters([]);
    } finally {
      setLoadingCenters(false);
    }
  }, []);

  
useEffect(() => {
  const timer = setTimeout(() => {

    if (selectedOC && searchTerm === selectedOC.value) {
      return;
    }

    if (searchTerm.trim() !== "") {
      searchOCs(searchTerm, 1, true); 
    } else {
      setSearchResults([]);
    }
  
  }, 300);

  return () => clearTimeout(timer);
}, [searchTerm, searchOCs, selectedOC]);

  useEffect(() => {
    loadCenters();
  }, [loadCenters]);
  
const handleSelectChange = (selectedOption) => {
  if (selectedOption) {

    setSelectedOC(selectedOption);
    setSearchTerm(selectedOption.value);
    searchOCs(selectedOption.value, 1, false);
    setSelectedRows([]);
    setAllSelected(false);
    setPartialQuantities({});
  } else {
    clearSearchState();
  }
};

  
const handleInputChange = (inputValue, actionMeta) => {

  if (actionMeta.action !== 'input-blur' && actionMeta.action !== 'menu-close') {
    setSearchTerm(inputValue);
    
    if (inputValue.trim() === "") {
      setSearchResults([]);
    }
  }
};

  const handleSelectCenter = (option) => {
    setSelectedCenter(option);
  };

  const handleQuantityChange = (posNumber, quantity) => {
    setPartialQuantities(prev => ({
      ...prev,
      [posNumber]: quantity
    }));
  };

const handleCheckboxChange = (id) => {
  const rowToSelect = tableData.find(row => row.id === id);
  
  if (rowToSelect && rowToSelect.canSchedule === false) {
    setAlertMessage(`Esta posición no está disponible para agendar: ${rowToSelect.scheduleReason}`);
    setShowAlertWarning(true);
    return;
  }
  
  setSelectedRows(prev => {
    const newSelectedRows = prev.includes(id) 
      ? prev.filter(rowId => rowId !== id)
      : [...prev, id];
    
    const selectableIds = allPositionIds.filter(pid => {
      const position = originalPositionsData.find(pos => pos.id === pid);
      return position?.canSchedule !== false;
    });
    
    const allSelectedNow = selectableIds.length > 0 && 
      selectableIds.every(pid => newSelectedRows.includes(pid));
    
    setAllSelected(allSelectedNow);
    
    const rowToDeselect = tableData.find(row => row.id === id);
    if (prev.includes(id) && rowToDeselect && rowToDeselect.pos) {
      setPartialQuantities(prevQuantities => {
        const newQuantities = {...prevQuantities};
        delete newQuantities[rowToDeselect.pos];
        return newQuantities;
      });
    }
    
    return newSelectedRows;
  });
};

const handleSelectAll = async (checked) => {
  setAllSelected(checked);
  if (checked) {
    setLoadingSearch(true);
    try {
      if (originalPositionsData.length < allPositionIds.length) {
        const firstResponse = await getPositionsPerOrder(supplierId, selectedOC.value, 1, pageSize);
        const totalPages = firstResponse.data.pagination?.totalPages || 1;
        
        let allPositions = [];
        
        if (firstResponse.data?.positions) {
          allPositions.push(...firstResponse.data.positions);
        }
        
        for (let page = 2; page <= totalPages; page++) {
          const response = await getPositionsPerOrder(supplierId, selectedOC.value, page, pageSize);
          if (response.data?.positions) {
            allPositions.push(...response.data.positions);
          }
        }
        
        const allOriginalData = [];
        allPositions.forEach(item => {
          const positionData = item.position || item;
          allOriginalData.push({
            id: positionData.id,
            orderId: positionData.orderId,
            orderNumber: positionData.orderNumber,
            positionNumber: positionData.positionNumber,
            description: positionData.description,
            cant: positionData.cant,
            unitWeight: positionData.unitWeight,
            emissionDate: positionData.emissionDate,
            deliveryDate: positionData.deliveryDate,
            pricePerUnit: positionData.pricePerUnit,
            canSchedule: item.scheduleAvailability?.canSchedule,
            scheduleReason: item.scheduleAvailability?.reason,
            statusName: item.lastStatus?.statusName
          });
        });
        
        setOriginalPositionsData(allOriginalData);
        
        const selectableIds = allPositionIds.filter(id => {
          const position = allOriginalData.find(pos => pos.id === id);
          return position ? position.canSchedule !== false : true;
        });
        setSelectedRows(selectableIds);
        
      } else {
        const selectableIds = allPositionIds.filter(id => {
          const position = originalPositionsData.find(pos => pos.id === id);
          return position ? position.canSchedule !== false : true;
        });
        setSelectedRows(selectableIds);
      }
      
    } catch (error) {
      console.error("Error al cargar todas las posiciones:", error);
      setAlertMessage("Error al cargar las posiciones. Por favor intente nuevamente.");
      setShowAlertWarning(true);
    } finally {
      setLoadingSearch(false);
    }
  } else {
    setSelectedRows([]);
    setPartialQuantities({});
  }
};

  const changePage = (page) => {
    if (page >= 1 && page <= totalPages) {
      searchOCs(searchTerm, page);
    }
  };


  // listar horarios
  const fetchSchedulesForDate = async (date) => {
    if (!date) return;
    
    try {
      setLoading(true);
      const formattedDate = formatDateForAPI(date);
      const response = await getSchedules(formattedDate, null, null);
      
      if (response.data && response.data.schedules) {
        setSchedules(response.data.schedules);
      } else {
        setSchedules([]);
        setSelectedTime("");
        setSelectedScheduleId(null);
      }
    } catch (error) {
      console.error('Error al obtener horarios:', error);
      setSchedules([]);
      setSelectedTime("");
      setSelectedScheduleId(null);
    } finally {
      setLoading(false);
    }
  };

  const generateTimeSlots = () => {
    return schedules
      .map(schedule => {
        const start = schedule.start_time.substring(0, 5); 
        const end = schedule.end_time.substring(0, 5);
        return `${start} - ${end}`;
      });
  };

  const generateSlotAvailability = () => {
    const availability = {};
    schedules
      .forEach(schedule => {
        const start = schedule.start_time.substring(0, 5);
        const end = schedule.end_time.substring(0, 5);
        const timeSlot = `${start} - ${end}`;
        availability[timeSlot] = schedule.queue_supplier;
      });
    return availability;
  };

const getUniquePOS = () => {
  if (selectedRows.length === 0) return [];
  
  const positionsMap = new Map();
  originalPositionsData.forEach(pos => {
    positionsMap.set(pos.id, pos);
  });
  
  const selectedPositions = selectedRows
    .map(id => positionsMap.get(id))
    .filter(pos => pos !== undefined); 
  
  const uniquePOS = [...new Set(
    selectedPositions
      .map(pos => pos.positionNumber?.toString())
      .filter(pos => pos && pos.trim() !== "")
  )];
  
  return uniquePOS.sort((a, b) => a.localeCompare(b, undefined, {numeric: true}));
};

const handleSaveOC = async () => {  
  if (!selectedOC || selectedRows.length === 0) {
    setAlertMessage("Por favor seleccione al menos una posición para guardar.");
    setShowAlertWarning(true);
    return;
  }

  if (!selectedCenter || !selectedCenter.id) {
    setAlertMessage("Por favor seleccione un centro de entrega.");
    setShowAlertWarning(true);
    return;
  }

  const availableIds = originalPositionsData.map(p => p.id);
  const missingIds = selectedRows.filter(id => !availableIds.includes(id));
  
  let completePositionsData = [...originalPositionsData];

  if (missingIds.length > 0) {
    setLoadingSearch(true);
    
    try {
      const positionsMap = new Map();
      
      originalPositionsData.forEach(pos => {
        positionsMap.set(pos.id, pos);
      });
      
      const firstResponse = await getPositionsPerOrder(supplierId, selectedOC.value, 1, pageSize);
      const totalPages = firstResponse.data.pagination?.totalPages || 1;
      
      if (firstResponse.data?.positions) {
        firstResponse.data.positions.forEach(item => {
          const positionData = item.position || item;
          if (!positionsMap.has(positionData.id)) {
            positionsMap.set(positionData.id, {
              id: positionData.id,
              orderId: positionData.orderId,
              orderNumber: positionData.orderNumber,
              positionNumber: positionData.positionNumber,
              description: positionData.description,
              cant: positionData.cant,
              unitWeight: positionData.unitWeight,
              emissionDate: positionData.emissionDate,
              deliveryDate: positionData.deliveryDate,
              pricePerUnit: positionData.pricePerUnit,
              canSchedule: item.scheduleAvailability?.canSchedule,
              scheduleReason: item.scheduleAvailability?.reason,
              statusName: item.lastStatus?.statusName
            });
          }
        });
      }
      
      for (let page = 2; page <= totalPages; page++) {
        const stillMissing = missingIds.filter(id => !positionsMap.has(id));
        if (stillMissing.length === 0) break;
        
        const response = await getPositionsPerOrder(supplierId, selectedOC.value, page, pageSize);
        if (response.data?.positions) {
          response.data.positions.forEach(item => {
            const positionData = item.position || item;
            if (!positionsMap.has(positionData.id)) {
              positionsMap.set(positionData.id, {
                id: positionData.id,
                orderId: positionData.orderId,
                orderNumber: positionData.orderNumber,
                positionNumber: positionData.positionNumber,
                description: positionData.description,
                cant: positionData.cant,
                unitWeight: positionData.unitWeight,
                emissionDate: positionData.emissionDate,
                deliveryDate: positionData.deliveryDate,
                pricePerUnit: positionData.pricePerUnit,
                canSchedule: item.scheduleAvailability?.canSchedule,
                scheduleReason: item.scheduleAvailability?.reason,
                statusName: item.lastStatus?.statusName
              });
            }
          });
        }
      }
      
      completePositionsData = Array.from(positionsMap.values());
      setOriginalPositionsData(completePositionsData);
      
    } catch (error) {
      console.error("Error al obtener posiciones faltantes:", error);
      setAlertMessage("Error al cargar todas las posiciones. Por favor intente nuevamente.");
      setShowAlertWarning(true);
      setLoadingSearch(false);
      return;
    } finally {
      setLoadingSearch(false);
    }
  }
  
  const selectedOriginalPositions = completePositionsData.filter(pos => 
    selectedRows.includes(pos.id)
  );

  if (selectedOriginalPositions.length === 0) {
    setAlertMessage("No se encontraron datos de las posiciones seleccionadas.");
    setShowAlertWarning(true);
    return;
  }

 const currentCenterForThisOC = {
    id: selectedCenter.id,
    name: selectedCenter.name,
  };

  const existingPositionIds = savedOCs.flatMap(savedOC => 
    savedOC.positions.map(pos => pos.id)
  );

  const duplicatePositions = selectedOriginalPositions.filter(pos => 
    existingPositionIds.includes(pos.id)
  );

  if (duplicatePositions.length > 0) {
    const duplicateNumbers = duplicatePositions.map(p => p.positionNumber).join(', ');
    setAlertMessage(`Las siguientes posiciones ya han sido guardadas: POS ${duplicateNumbers}. No se pueden guardar nuevamente.`);
    setShowAlertWarning(true);
    return;
  }

  if (deliveryType === 'partial') {
    const hasEmptyFields = selectedOriginalPositions.some(pos => {
      const posQuantity = partialQuantities[pos.positionNumber];
      return posQuantity === undefined || posQuantity === "";
    });

    if (hasEmptyFields) {
      setAlertMessage("Para entrega parcial, debe especificar la cantidad para cada posición seleccionada.");
      setShowAlertWarning(true);
      return;
    }
    
    const hasInvalidQuantities = selectedOriginalPositions.some(pos => {
      const posQuantity = parseFloat(partialQuantities[pos.positionNumber]);
      return isNaN(posQuantity) || posQuantity <= 0;
    });

    if (hasInvalidQuantities) {
      setAlertMessage("La cantidad de entrega debe ser mayor que 0 para cada posición.");
      setShowAlertWarning(true);
      return;
    }

    const exceedsAvailable = selectedOriginalPositions.some(pos => {
      const requested = parseFloat(partialQuantities[pos.positionNumber]);
      const available = parseFloat(pos.cant);
      return requested > available;
    });

    if (exceedsAvailable) {
      setAlertMessage("Las cantidades solicitadas no pueden exceder la cantidad disponible.");
      setShowAlertWarning(true);
      return;
    }
  }

  const positionsWithDeliveryType = selectedOriginalPositions.map(pos => {
    let requestedQuantity;
    let deliveryTypeForPos;
    
    if (deliveryType === 'partial') {
      requestedQuantity = parseFloat(partialQuantities[pos.positionNumber]);
      deliveryTypeForPos = 'Parcial';
    } else {
      requestedQuantity = parseFloat(pos.cant);
      deliveryTypeForPos = 'Completa';
    }
    
    const availableQuantity = parseFloat(pos.cant);
    
    return {
      id: pos.id,
      positionNumber: pos.positionNumber,
      description: pos.description,
      requestedQuantity,
      availableQuantity,
      deliveryType: deliveryTypeForPos,
      orderNumber: pos.orderNumber,
      statusName: pos.statusName,
      centerId: currentCenterForThisOC.id,
      centerName: currentCenterForThisOC.name,
    };
  });

  setSavedOCs(prev => {
    const existingOCIndex = prev.findIndex(oc => oc.ocNumber === selectedOC.value);
    
    let updatedSavedOCs;
    
    if (existingOCIndex >= 0) {

      const updatedOCs = [...prev];
      updatedOCs[existingOCIndex] = {
        ...updatedOCs[existingOCIndex],
        positions: [
          ...updatedOCs[existingOCIndex].positions,
          ...positionsWithDeliveryType
        ]
      };
      updatedSavedOCs = updatedOCs;
    } else {
      const newOC = {
        ocNumber: selectedOC.value,
        positions: positionsWithDeliveryType,
        centerId: currentCenterForThisOC.id,
        centerName: currentCenterForThisOC.name,
        date: new Date().toISOString()
      };
      updatedSavedOCs = [...prev, newOC];
    }
    
    updatedSavedOCs.forEach((oc, index) => {

    });
    

    return updatedSavedOCs;
  });

  clearSearchState();
  setSelectedCenter("");
};

const clearSearchState = () => {
  setSelectedOC(null);
  setSearchTerm("");
  setSearchResults([]);
  setTableData([]);
  setOriginalPositionsData([]);
  setAllPositionIds([]);
  setSelectedRows([]);
  setAllSelected(false);
  setPartialQuantities({});
  setTotalPositions(0);
  setTotalPages(1);
  setCurrentPage(1);
  
  const cacheKeys = Object.keys(searchCache);
  cacheKeys.forEach(key => {
    if (key.includes(selectedOC?.value)) {
      delete searchCache[key];
    }
  });
};

const handleScheduleAll = async () => {
  if (savedOCs.length === 0) {
    setAlertMessage("No hay OCs guardadas para agendar.");
    setShowAlertWarning(true);
    return;
  }

  if (!selectedScheduleId) {
    setAlertMessage("Por favor seleccione un horario.");
    setShowAlertWarning(true);
    return;
  }

  if (!contactNumber || contactNumber.trim() === "") {
    setAlertMessage("Por favor ingrese un número de contacto.");
    setShowAlertWarning(true);
    return;
  }

  try {
    setLoadingAppointment(true);

    const allPositions = savedOCs.flatMap(savedOC => 
      savedOC.positions.map(pos => ({
        id: pos.id,
        cant: pos.requestedQuantity,
        centerId: pos.centerId,
      }))
    );


    const appointmentRequest = {
      scheduleId: selectedScheduleId,
      supplierId: supplierId,
      contact_number: contactNumber, 
      purOrdPosIds: allPositions
    };


    const response = await createAppointment(appointmentRequest);
        
    if (response.status === 201) {
      if (response.data.message) {
        setSuccessMessage(response.data.message);
      } else {
        setSuccessMessage("¡Su visita fue agendada con éxito!");
      }
      
      setSavedOCs([]);
      setContactNumber("");
      setShowModalSuccess(true);
    } else {
      setAlertMessage("Error al agendar la cita. Por favor intente nuevamente.");
      setShowAlertWarning(true);
    }

  } catch (error) {
    console.error("Error al agendar citas:", error);
    
    if (error.response?.data?.errors) {
      const errorMessages = error.response.data.errors.join('\n');
      setAlertMessage(`Errores en las cantidades:\n${errorMessages}`);
    } else if (error.response?.data?.message) {
      setAlertMessage(error.response.data.message);
    } else {
      setAlertMessage("Error al procesar las citas. Por favor intente nuevamente.");
    }
    
    setShowAlertWarning(true);
  } finally {
    setLoadingAppointment(false);
  }
};
  
  //TABLA PARA SELECCIONAR POS DE OCS

  const tableConfig = {
    headers: ['#', 'Número OC', 'POS', 'Pedido', 'Cant.', 'Un.',  'Fecha de emisión', 'Fecha de entrega', 'Precio', 'Razón', 'Detalles'],
    accessors: ['id', 'numeroOC', 'pos', 'pedido', 'cantidad', 'unidad',  'fechaEmision', 'fechaEntrega', 'precio', 'razon', 'detalles'],
    widths: ['48px', '111px', '111px', '260px', '111px', '112px',  '112px', '111px', '111px', '127px', '127px']
  };
  

  // TABLA DE POS SELECCIONADAS

  const tablePreview = {
    headers: ['#', 'Número OC', 'POS', 'Descripción de OC', 'Cantidad', 'Estado',  'Fecha de emisión', 'Tipo de entrega', 'Lugar de entrega', 'Ver detalle completo', 'Eliminar'],
    accessors: ['id', 'numeroOC', 'pos', 'descripcion', 'cantidad', 'estado',  'fechaEmision', 'tipoEntrega', 'lugarEntrega',  'detalles', 'eliminar'],
    widths: ['48px', '111px', '111px', '212px', '111px', '115px',  '112px', '111px', '127px',  '127px', '127px']
  };
  

  const openModalSuccess = () => {
 
    handleScheduleAll();
  };

  const uniquePOS = getUniquePOS();

const handleCancel = () => {
  setSelectedOC(null);
  setSearchTerm("");
  setSearchResults([]);
  setTableData([]);
  setOriginalPositionsData([]);
  setAllPositionIds([]);
  setSelectedRows([]);
  setAllSelected(false);
  setPartialQuantities({});
  setTotalPositions(0);
  setTotalPages(1);
  setCurrentPage(1);
  setSelectedCenter("");
  setDeliveryType('complete');
  
  setSavedOCs([]);
  setContactNumber("");

  setSelectedDate(null);
  setSelectedTime("");
  setSelectedScheduleId(null);

  const cacheKeys = Object.keys(searchCache);
  cacheKeys.forEach(key => {
    delete searchCache[key];
  });

   setCollapsedTables({});
  
   setSelectedDate(null);
   setSelectedTime("");
   setSelectedScheduleId(null);
};

const handleCancelPos = () => {

  setSelectedRows([]);
  setAllSelected(false);
  setPartialQuantities({});
  setSelectedCenter("");
  setDeliveryType('complete');

};

const handleDeleteOC = (ocNumberToDelete) => {
  setSavedOCs(prev => {
    const updatedOCs = prev.filter(oc => oc.ocNumber !== ocNumberToDelete);
    
    return updatedOCs;
  });
};

const handleDeletePosition = (ocNumber, positionId) => {
  setSavedOCs(prev => {
    const updatedOCs = prev.map(oc => {
      if (oc.ocNumber === ocNumber) {
        const updatedPositions = oc.positions.filter(pos => pos.id !== positionId);
        
        return {
          ...oc,
          positions: updatedPositions
        };
      }
      return oc;
    }).filter(oc => oc.positions.length > 0); 

    return updatedOCs;
  });
};

  return (
    <div>
        <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300"/>
        <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
          <div className="pt-8 pb-10 px-[5%] sm:px-[3%] flex flex-col gap-4">
            <h1 className="text-blue font-itcbold md:text-[32px] text-2xl">
              Agenda tu cita
            </h1>
            <h2 className="text-[#6B7280] font-itcbook md:text-2xl text-xl">
              Aquí podrás agendar tu cita para entrega de materiales
            </h2>
            {adminContact && (
              <div 
                className="overflow-hidden text-base break-words whitespace-normal link font-itcbook text-blue-dark"
                dangerouslySetInnerHTML={{
                  __html: (adminContact || "-").split(/\s+/).slice(0, 300).join(' ')
                }}
                style={{ 
                  hyphens: 'auto',
                  WebkitHyphens: 'auto',
                  msHyphens: 'auto'
                }}
              />
            )}

            <p className="text-xl text-blue font-itcmedium md:text-2xl">
              Escoge el día y horario disponible
            </p>

            <div className="flex flex-col sm:flex-row">
              <div className="flex flex-col w-full sm:w-1/2">
                <h3 className="text-left text-white px-4 p-2 font-itcbold bg-blue md:text-[20px] text-base">
                  Calendario
                </h3>
                <div className="flex items-start bg-[#0076961A] sm:px-12 p-8 justify-center ">
                  <CalendarSingleDate
                    onDateSelect={handleDateSelect}
                    selectedDate={selectedDate}
                  />
                </div>
              </div>
              <div className="flex flex-col w-full sm:w-1/2">
                <h3 className="text-left sm:block hidden text-white px-4 p-2 font-itcbold bg-blue  md:text-[20px] text-base">
                  Escoger horarios
                </h3>
                <div className="flex flex-col gap-3 py-4 sm:p-4">
                  <h2 className="text-lg text-blue font-itcbold">
                    Escoger horario:
                  </h2>
                  
                  <p className="text-[#2F2F3B] font-itcdemi text-base">
                    {selectedDate && formatDisplayDate(selectedDate)}
                  </p>

                  {loading ? (
                    <div className="py-4 text-center">
                      <p className="text-blue">Cargando horarios...</p>
                    </div>
                  ) : selectedDate ? (
                    schedules.length > 0 ? (
                  <>
                  <div className="grid grid-cols-3 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                    <TimeSlotSchedule
                      timeSlots={generateTimeSlots()}
                      selectedTime={selectedTime}
                      onTimeSelect={handleSelectTime}
                      slotAvailability={generateSlotAvailability()}
                      tooltipText="cupos disponibles"
                    />
                  </div>
                  <InputField
                    title="Número de contacto"
                    required={true}
                    name="contactNumber"
                    value={contactNumber}
                    onChange={(e) => setContactNumber(e.target.value)}
                    type="tel"
                    validation="phone"
                    placeholder="Ingrese número"
                    horizontal={false}
                  />
                  </>
                    ): (
                      <div className="py-8 text-center font-itcdemi">
                        <p className="text-gray">No hay horarios disponibles para esta fecha</p>
                      </div>
                    )

                  ): (
                    <div className="py-4 text-center font-itcdemi">
                      <p className="text-gray-500">Selecciona una fecha en el calendario</p>
                    </div>
                  )}

                </div>
              </div>
            </div>

            {savedOCs.length > 0 && (
              <>
                {savedOCs.map((savedOC, index) => (
                  <div key={index} className="flex flex-col w-full gap-2">

                    <div className="flex items-center gap-2">
                      <h3 className="text-lg font-itcbold text-blue">
                        Número de OC: {savedOC.ocNumber}
                      </h3>

                      <button
                        onClick={() => handleDeleteOC(savedOC.ocNumber)}
                        className='group' 
                        title="Eliminar OC" 
                      >
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15.241 3.721L15.534 5.75H19.5C19.6989 5.75 19.8897 5.82902 20.0303 5.96967C20.171 6.11032 20.25 6.30109 20.25 6.5C20.25 6.69891 20.171 6.88968 20.0303 7.03033C19.8897 7.17098 19.6989 7.25 19.5 7.25H18.731L17.858 17.435C17.805 18.055 17.762 18.565 17.693 18.977C17.623 19.406 17.516 19.79 17.307 20.146C16.9788 20.7051 16.4909 21.1533 15.906 21.433C15.534 21.61 15.142 21.683 14.708 21.717C14.291 21.75 13.78 21.75 13.158 21.75H10.842C10.22 21.75 9.709 21.75 9.292 21.717C8.858 21.683 8.466 21.61 8.094 21.433C7.50908 21.1533 7.02118 20.7051 6.693 20.146C6.483 19.79 6.378 19.406 6.307 18.977C6.238 18.564 6.195 18.055 6.142 17.435L5.269 7.25H4.5C4.30109 7.25 4.11032 7.17098 3.96967 7.03033C3.82902 6.88968 3.75 6.69891 3.75 6.5C3.75 6.30109 3.82902 6.11032 3.96967 5.96967C4.11032 5.82902 4.30109 5.75 4.5 5.75H8.466L8.759 3.721L8.77 3.66C8.952 2.87 9.63 2.25 10.48 2.25H13.52C14.37 2.25 15.048 2.87 15.23 3.66L15.241 3.721ZM9.981 5.75H14.018L13.762 3.974C13.714 3.807 13.592 3.75 13.519 3.75H10.481C10.408 3.75 10.286 3.807 10.238 3.974L9.981 5.75ZM11.25 10.5C11.25 10.3011 11.171 10.1103 11.0303 9.96967C10.8897 9.82902 10.6989 9.75 10.5 9.75C10.3011 9.75 10.1103 9.82902 9.96967 9.96967C9.82902 10.1103 9.75 10.3011 9.75 10.5V15.5C9.75 15.6989 9.82902 15.8897 9.96967 16.0303C10.1103 16.171 10.3011 16.25 10.5 16.25C10.6989 16.25 10.8897 16.171 11.0303 16.0303C11.171 15.8897 11.25 15.6989 11.25 15.5V10.5ZM14.25 10.5C14.25 10.3011 14.171 10.1103 14.0303 9.96967C13.8897 9.82902 13.6989 9.75 13.5 9.75C13.3011 9.75 13.1103 9.82902 12.9697 9.96967C12.829 10.1103 12.75 10.3011 12.75 10.5V15.5C12.75 15.6989 12.829 15.8897 12.9697 16.0303C13.1103 16.171 13.3011 16.25 13.5 16.25C13.6989 16.25 13.8897 16.171 14.0303 16.0303C14.171 15.8897 14.25 15.6989 14.25 15.5V10.5Z"
                          fill="#6B7280"
                          className="transition-colors duration-200 group-hover:fill-red"/>
                          </svg>
                      </button>
                    </div>
                    
                    <div className="flex w-full">
                      <div className="w-full overflow-hidden">
                        <DynamicTable 
                          data={savedOC.positions.map((pos, idx) => ({
                            id: idx + 1,
                            numeroOC: savedOC.ocNumber,
                            pos: pos.positionNumber,
                            descripcion: pos.description,
                            cantidad: `${pos.requestedQuantity} / ${pos.availableQuantity}`,
                            estado: pos.statusName,
                            fechaEmision: formatDisplayDate(new Date()),
                            tipoEntrega: pos.deliveryType,
                            lugarEntrega: pos.centerName || '', 
                            fechaEntrega: formatDisplayDate(new Date()),
                            detalles: () => handleViewDetails(pos.id),
                            eliminar: () => handleDeletePosition(savedOC.ocNumber, pos.id) 
                          }))}
                          config={tablePreview}
                          showPagination={false}
                          collapsed={collapsedTables[index]}
                          statusColors={statusColors}
                        />
                      </div>
                      <button
                        onClick={() => toggleTableCollapse(index)}
                        className={`border-[1px] flex transition-all duration-300 justify-center items-center w-[55px] h-[61px] 
                        ${collapsedTables[index] ? 'bg-white' : 'bg-[#58B6E538]'}
                         border-[#D9D9D9] rounded-tr-2xl rounded-br-2xl`}>
                        <svg
                          width="18"
                          height="19"
                          viewBox="0 0 18 19"
                          fill="none"
                          className={`transform transition-transform duration-300 ${collapsedTables[index] ? 'rotate-180' : ''}`}  xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.55859 7.13477H13.4395C13.7115 7.13507 13.8521 7.46493 13.6631 7.66113L9.77832 11.5459C9.37771 11.9465 8.7406 11.9718 8.31055 11.6211L8.22754 11.5459L4.34277 7.66113C4.14695 7.46531 4.28568 7.13516 4.55859 7.13477Z" fill="#292D32" stroke="#6B7280"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                ))}
              </>
            )}
          
            <div className="relative flex items-center w-full gap-4">
              <div className="relative flex items-center w-full gap-3">
                <label className="block  text-sm font-itcbook text-[#111928]">
                  Seleccionar OC
                </label>
                <Select
                  options={searchResults}
                  value={selectedOC}
                  onChange={handleSelectChange}
                  onInputChange={handleInputChange}
                  placeholder="Escriba el número de OC"
                  isClearable
                  isSearchable
                  isLoading={loadingSearch}
                  styles={selectStyles}
                  loadingMessage={() => "Cargando..."}
                  noOptionsMessage={({ inputValue }) => 
                    inputValue ? "No se encontraron resultados" : "Escriba para buscar OCs"
                  }
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </div>

              {loadingSearch && (
                <div className="mt-6 ml-2">
                  <svg className="w-5 h-5 animate-spin text-blue" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </div>
              )}
            </div>

            {selectedOC ? (
              tableData.length > 0 ? (
              <div className="flex flex-col gap-2 sm:flex-row">
              <div className="w-full overflow-hidden sm:w-1/2">
                <DynamicTable 
                  data={tableData}
                  config={tableConfig}
                  showPagination={true}
                  showRadioButtons={true}
                  selectedRows={selectedRows}
                  onCheckboxChange={handleCheckboxChange}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  changePage={changePage}
                  recordsPerPage={pageSize}
                  totalRecords={totalPositions}
                  onSelectAll={handleSelectAll}
                  allSelected={allSelected}
                  statusColors={reasonColors}
                />
              </div>
              {uniquePOS.length > 0 ? (
                <div className="w-full sm:w-1/2">
                <div className="flex flex-col gap-4 sm:px-5">
                  <h3 className="text-base md:text-lg text-blue font-itcbold">Tipo de entrega:</h3>
                  <div className="flex gap-4">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input 
                        type="radio"
                        name="deliveryType"
                        checked={deliveryType === 'complete'}
                        onChange={() => setDeliveryType('complete')} 
                        className="w-5 h-5 appearance-none border-[#C4C7CC] border-[1px] checked:bg-[#43B02A] checked:border-transparent cursor-pointer rounded-[3px] focus:ring-[#43B02A]"
                      />
                      <span className="text-sm font-itcmedium">Entrega completa</span>
                    </label>
                              
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input 
                        type="radio"
                        name="deliveryType" 
                        checked={deliveryType === 'partial'}
                        onChange={() => setDeliveryType('partial')}
                        className="w-5 h-5 appearance-none border-[#C4C7CC] border-[1px] checked:bg-[#43B02A] checked:border-transparent cursor-pointer rounded-[3px] focus:ring-[#43B02A]"
                      />
                      <span className="text-sm font-itcmedium">Entrega parcial</span>
                    </label>
                  </div>

                  {deliveryType === 'partial' && (
                  <>
                  <h3 className="text-base text-blue font-itcbold md:text-lg">Cantidad exacta de entrega: <span className="text-red-500">*</span></h3>
                  
                  {uniquePOS.length > 0 ? (

                    <div className="grid grid-cols-2 gap-3">
                      {uniquePOS.map((posNumber, index) => (

                      <div className="flex flex-col gap-2">
                        <p className="text-[#76A140] font-itcmedium text-sm">POS {posNumber}:</p>
                        <div className="relative w-full">
                          <input
                            type="text"
                            value={partialQuantities[posNumber] || ""}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              const posRecord = originalPositionsData.find(item => item.positionNumber?.toString() === posNumber);
                              const maxQuantity = posRecord ? parseFloat(posRecord.cant) : 0;
                              
                              const cleanedValue = inputValue.replace(/[^0-9.]/g, '');
                              
                              const parts = cleanedValue.split('.');
                              if (parts.length > 2) {
                                const validValue = parts[0] + '.' + parts.slice(1).join('');
                                e.target.value = validValue;
                                return;
                              }
                              
                              if (parts.length === 2 && parts[1].length > 2) {
                                return; 
                              }
                              
                              // Permitir campo vacío
                              if (cleanedValue === "") {
                                handleQuantityChange(posNumber, "");
                                return;
                              }
                              
                              const numericValue = parseFloat(cleanedValue);
                              
                              if (!isNaN(numericValue) && numericValue > maxQuantity) {
                                handleQuantityChange(posNumber, maxQuantity.toFixed(2));
                              } else {
                                handleQuantityChange(posNumber, cleanedValue);
                              }
                            }}
                            onBlur={(e) => {
                              const value = e.target.value;
                              if (value && value !== "") {
                                const numericValue = parseFloat(value);
                                if (!isNaN(numericValue)) {
                                  // Formatear a 2 decimales
                                  handleQuantityChange(posNumber, numericValue.toFixed(2));
                                }
                              }
                            }}
                            placeholder="Ingrese cantidad"
                            className="w-full h-[40px] px-3 text-sm font-itcbook bg-transparent border border-black rounded-md outline-none placeholder:text-[#6B7280] "
                            maxLength={15}
                          />

                        </div>
                      </div>
                      ))}
                    </div>
                   ) : (
                    <div className="py-3 text-center">
                      <p className="text-sm text-gray font-itcbook">
                        Seleccione una o más POS
                      </p>
                    </div>
                  )}
                  </>
                  )}

                  <h3 className="text-base text-blue font-itcbold md:text-lg">Lugar de entrega:</h3>
                    <FilterSelect
                      text="Seleccione ubicación"
                      options={centers.map(center => center.name)} 
                      onSelect={(selectedName) => {
                        const selectedCenter = centers.find(center => center.name === selectedName);
                        if (selectedCenter) {
                          handleSelectCenter(selectedCenter); 
                        }
                      }}
                      selectedOption={selectedCenter?.name || ""} 
                      bgColor="bg-transparent"
                      border="border-black"
                    />

                  <div className="flex gap-3 mt-6 lg:w-[60%] ">
                    <SaveButton 
                      onClick={handleSaveOC}
                      height="h-[45px] sm:h-[50px]"
                      width="w-[161px]"
                      rounded="[8px]"
                    />
                    <CancelButton
                      onClick={handleCancelPos}
                      height="h-[45px] sm:h-[50px]"
                      width="w-[161px]"
                      rounded="[8px]"
                    />
                  </div>
                </div>
                </div>
              ) : (
                <div className="flex items-center justify-center w-full sm:w-1/2 ">
                  <p className="text-sm text-gray font-itcbook">
                    Seleccione al menos una POS para continuar.
                  </p>
                </div>
              )}
            </div>
            ) :  (
                <div className="py-8 text-center font-itcdemi">
                  <p className="text-gray">No se encontraron datos para esta OC</p>
                </div>
            ) 
          ): null}


            <div className="flex items-center justify-center">
              <div className="flex flex-col sm:flex-row w-[90%] sm:w-[65%] pt-10 gap-3 sm:gap-7 items-center justify-center">
                <SaveButton
                  onClick={openModalSuccess}
                  title={loadingAppointment ? "Agendando..." : "Agendar"}
                  height="h-[54px] sm:h-[64px]"
                  width="w-[250px]"
                  loading={loadingAppointment}
                  disabled={loadingAppointment}
                />
                <CancelButton 
                onClick={handleCancel}
                  height="h-[54px] sm:h-[64px]"
                  width="w-[250px]"
                />
              </div>
            </div>
          </div>
        </div>
        <ModalDateSuccess 
          showModalSuccess={showModalSuccess} 
          closeModalSuccess={() => {
            setShowModalSuccess(false);
            setSuccessMessage(''); 
          }}
          successMessage={successMessage}
        />

            {showPdfModal && (
              <PdfViewerModal
                pdfFile={pdfUrl}
                onClose={() => setShowPdfModal(false)}
              />
            )}

<ModalAlertWarning
  showModalAlertWarning={showAlertWarning}
  closeModal={() => setShowAlertWarning(false)}
  error={alertMessage}
  accept={() => setShowAlertWarning(false)}
/>
    </div>
  );
}